import { render, staticRenderFns } from "./phone-preview.vue?vue&type=template&id=7fe516b3"
import script from "./phone-preview.vue?vue&type=script&lang=js"
export * from "./phone-preview.vue?vue&type=script&lang=js"
import style0 from "./phone-preview.vue?vue&type=style&index=0&id=7fe516b3&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports